<ng-container *transloco="let t; prefix: 'products'">

    @if (featuredProductsLoaded()) {
        <div class="featured-products-container">
            <div class="featured-product-title">
                <mat-divider></mat-divider>
                <span class="title-large">Prodotti in evidenza</span>
                <mat-divider></mat-divider>
            </div>
        
            <div class="carousel-wrapper">
                <button mat-icon-button class="carousel-arrow carousel-arrow--left"
                    [disabled]="!canScrollLeft()"
                    (click)="scrollLeft()"
                    (mousedown)="startScroll('left')" (mouseup)="stopScroll()" (mouseleave)="stopScroll()"
                    (touchstart)="startScroll('left')" (touchend)="stopScroll()">
                    <i class="fa-solid fa-chevron-left"></i>
                </button>
            
                <div class="carousel-track" cdkScrollable>
                    @for (product of featuredProducts; track product.idProdotto) {
                        <mat-card class="product-card">
                            <div class="card-body">
                            
                                <div class="card-row card-row-header">
                                    <span class="product-name title-medium emphasized">{{ product.nomeProdotto }}</span>
                                    <prd-availability-chip [stock]="product.stock" />
                                </div>
                            
                                <div class="body-medium featured-product-description">
                                    {{ product.plc1 }} - {{ product.plc2 }}
                                </div>
                            
                                <div class="card-row card-row-categories">
                                    <prd-category-chip [badges]="product.badge" />
                                </div>
                            
                                <div class="card-row card-row-footer">
                                    <span class="title-medium emphasized">
                                        {{ product.prezzo | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
                                    </span>
                                    <button matButton="filled" class="cart-button" (click)="openAddToCartDialog($event, product)">
                                        <i class="fa-regular fa-cart-arrow-down"></i>
                                        Aggiungi al carrello
                                    </button>
                                </div>
                            
                            </div>
                        </mat-card>
                    }
                </div>
            
                <button mat-icon-button class="carousel-arrow carousel-arrow--right"
                    [disabled]="!canScrollRight()"
                    (click)="scrollRight()"
                    (mousedown)="startScroll('right')" (mouseup)="stopScroll()" (mouseleave)="stopScroll()"
                    (touchstart)="startScroll('right')" (touchend)="stopScroll()">
                    <i class="fa-solid fa-chevron-right"></i>
                </button>
            </div>
        </div>
    }

    <span class="title-medium emphasized section-title">Catalogo prodotti</span>

    <form class="form" [formGroup]="filtersForm">
        <div class="searchbar-row">
            <mat-form-field appearance="outline" class="searchbar" subscriptSizing="dynamic">
                <input matInput placeholder="Cerca prodotto" formControlName="searchText">
                <div matSuffix class="search-icon-wrapper">
                    <i class="fa-regular fa-magnifying-glass"></i>
                </div>
            </mat-form-field>

            <button type="button" matButton class="filter-trigger-button" (click)="toggleFilters()">
                <i class="fa-regular fa-filter"></i>
                Filtri
            </button>
        </div>
    </form>

    <div class="actions">
        <button matButton (click)="exportPriceList('xlsx')">
            <i class="fa-regular fa-download"></i>
            Excel
        </button>
        <button matButton (click)="exportPriceList('pdf')">
            <i class="fa-regular fa-download"></i>
            PDF
        </button>
    </div>

    @if (filtersOpen()) {
        <form class="filters-card-form" [formGroup]="filtersForm">
            <mat-card class="filters-card">
                <mat-card-content class="filters-card-content">

                    <mat-button-toggle-group
                        class="toggle plc-type-toggle"
                        hideSingleSelectionIndicator="true"
                        [value]="plcType()"
                        (change)="onPlcTypeChange($event.value)">
                        <mat-button-toggle value="">Tutti</mat-button-toggle>
                        <mat-button-toggle value="OIL">Oil</mat-button-toggle>
                        <mat-button-toggle value="NONOIL">Non Oil</mat-button-toggle>
                    </mat-button-toggle-group>

                    <div class="price-filters-row">
                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>Prezzo minimo</mat-label>
                            <input matInput type="number" formControlName="prezzoMin" placeholder="0,00">
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>Prezzo massimo</mat-label>
                            <input matInput type="number" formControlName="prezzoMax" placeholder="0,00"
                                [min]="filtersForm.controls.prezzoMin.value">
                            @if (filtersForm.controls.prezzoMax.hasError('min')) {
                                <mat-error>Deve essere maggiore o uguale al prezzo minimo</mat-error>
                            }
                        </mat-form-field>
                    </div>

                    <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                        <mat-label>PLC1</mat-label>
                        <mat-select formControlName="plc1" multiple placeholder="Tutti">
                            @for (opt of visiblePlc1Options; track opt.value) {
                                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                        <mat-label>PLC2</mat-label>
                        <mat-select formControlName="plc2" multiple placeholder="Tutti">
                            @for (opt of visiblePlc2Options; track opt.value) {
                                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    @if (plcType() !== 'NONOIL') {
                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>Tipo olio</mat-label>
                            <mat-select formControlName="tipiOlio" multiple placeholder="Tutti">
                                @for (opt of tipiOlioOptions; track opt.value) {
                                    <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                            <mat-label>Segmento mercato</mat-label>
                            <mat-select formControlName="segmentiMercato" multiple placeholder="Tutti">
                                @for (opt of segmentiMercatoOptions; track opt.value) {
                                    <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }

                    <mat-checkbox class="filter-field" formControlName="disponibili">Solo disponibili</mat-checkbox>

                    <button type="button" matButton class="filter-trigger-button advanced-filters-trigger" (click)="toggleAdvancedFilters()">
                        <i class="fa-regular fa-filter"></i>
                        Filtri avanzati
                    </button>

                    @if (advancedFiltersOpen()) {
                        <div class="technical-filter">
                            <span class="body-medium emphasized technical-filter-title">Filtro tecnico</span>

                            @for (category of technicalFilterCategories; track category.key) {
                                <div class="technical-filter-row">
                                    <span class="body-medium technical-filter-row-title">{{ category.label }}</span>
                                    <mat-chip-listbox multiple="true">
                                        @for (option of category.options; track option) {
                                            <mat-chip-option
                                                [selected]="isTechnicalFilterSelected(category.key, option)"
                                                (selectionChange)="onTechnicalFilterSelect($event, category.key, option)">
                                                {{ option }}
                                            </mat-chip-option>
                                        }
                                    </mat-chip-listbox>
                                </div>
                            }
                        </div>

                        <div class="competitor-filter">
                            <span class="body-medium emphasized competitor-filter-title">Ricerca corrispettivo competitor</span>

                            <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                                <mat-label>Marchio</mat-label>
                                <input matInput formControlName="competitorMarchio" [matAutocomplete]="autoCompetitorMarchio" placeholder="Tutti">
                                <span matSuffix class="autocomplete-suffix">
                                    @if (filtersForm.get('competitorMarchio')?.value) {
                                        <button mat-icon-button type="button" class="clear-suffix-button round-icon-button"
                                            aria-label="Svuota marchio" (click)="clearFilterField('competitorMarchio')">
                                            <i class="fa-regular fa-xmark"></i>
                                        </button>
                                    } @else {
                                        <i class="fa-regular fa-chevron-down icon-suffix"></i>
                                    }
                                </span>
                                <mat-autocomplete #autoCompetitorMarchio="matAutocomplete">
                                    @for (opt of filteredCompetitorMarchio | async; track opt) {
                                        <mat-option [value]="opt">{{ opt }}</mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
                                <mat-label>Nome prodotto</mat-label>
                                <input matInput formControlName="competitorNomeProdotto" [matAutocomplete]="autoCompetitorNomeProdotto" placeholder="Tutti">
                                <span matSuffix class="autocomplete-suffix">
                                    @if (filtersForm.get('competitorNomeProdotto')?.value) {
                                        <button mat-icon-button type="button" class="clear-suffix-button round-icon-button"
                                            aria-label="Svuota nome prodotto" (click)="clearFilterField('competitorNomeProdotto')">
                                            <i class="fa-regular fa-xmark"></i>
                                        </button>
                                    } @else {
                                        <i class="fa-regular fa-chevron-down icon-suffix"></i>
                                    }
                                </span>
                                <mat-autocomplete #autoCompetitorNomeProdotto="matAutocomplete">
                                    @for (opt of filteredCompetitorNomeProdotto | async; track opt) {
                                        <mat-option [value]="opt">{{ opt }}</mat-option>
                                    }
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    }

                </mat-card-content>

                <mat-card-actions align="end">
                    <button matButton type="button" (click)="resetFilters()">Annulla</button>
                    <button matButton="filled" type="button" [disabled]="filtersForm.invalid"
                        (click)="applyFilters()">Applica</button>
                </mat-card-actions>
            </mat-card>
        </form>
    }

    <div class="active-filters">
        <span class="body-medium emphasized">Filtri attivi: </span>
        <mat-chip-set>
            @for (filter of getActiveTechnicalFilters(); track filter.value) {
                <mat-chip (removed)="removeTechnicalFilter(filter.key, filter.value)">
                    {{ filter.value }}
                    <button matChipRemove aria-label="Rimuovi filtro">
                        <i class="fa-regular fa-xmark"></i>
                    </button>
                </mat-chip>
            }
        </mat-chip-set>
    </div>

    <div class="view-bar">
        <mat-button-toggle-group
            [value]="selectedView"
            (change)="onViewChange($event.value)"
            class="toggle"
            hideSingleSelectionIndicator="true">
            @for (option of viewOptions; track option.value) {
                @if (!isMobile || option.value !== 'list') {
                    <mat-button-toggle [value]="option.value">
                        <i [attr.class]="'fa-' + option.iconVariant + ' ' + option.icon"></i> {{ option.label }}
                    </mat-button-toggle>
                }
            }
        </mat-button-toggle-group>
    </div>

    @switch (selectedView) {
        @case ('list') {
            <ui-table-view
                class="table-view"
                [data]="tableProducts"
                [columnsInfo]="columnsInfo"
                [sortColumns]="currentSortColumns"
                (sortChange)="onSortChange($event)"
                (rowClicked)="openProductDetail($event.idProdotto)">
            </ui-table-view>
        }
        @case ('card') {
            <div class="catalog-card-list">
                @for (product of catalogProducts; track product.idProdotto) {
                    <mat-card class="catalog-card" (click)="openProductDetail(product.idProdotto)">
                        <mat-card-content>
                            <div class="catalog-card-header">
                                <span class="body-medium emphasized">{{ product.nomeProdotto }}</span>
                                <prd-availability-chip [stock]="product.stock" />
                            </div>

                            <span class="body-small">{{ product.plc1 }} - {{ product.plc2 }}</span>

                            <div class="catalog-card-price-row">
                                <div class="title-medium emphasized catalog-card-price">
                                    {{ product.prezzo | translocoCurrency: 'symbol' : { minimumFractionDigits: 2, maximumFractionDigits: 2 } }}
                                </div>
                                <div class="catalog-card-badges">
                                    <prd-category-chip [badges]="product.badge" />
                                </div>
                            </div>

                            <mat-divider></mat-divider>

                            <div class="catalog-card-details">
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">Cod. prodotto</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.sku }}</span>
                                </div>
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">Nome imballo</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.nomeImballo }}</span>
                                </div>
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">Qtà fatturabile</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.unitaFatturabile }} {{ product.unitaMisura }}</span>
                                </div>
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">Scala</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.scala }}</span>
                                </div>
                                <div class="catalog-card-detail-item">
                                    <span class="catalog-card-detail-label body-medium">Deposito</span>
                                    <span class="catalog-card-detail-value body-medium emphasized">{{ product.deposito }}</span>
                                </div>
                            </div>

                            <button matButton="filled" class="catalog-cart-button" (click)="openAddToCartDialog($event, product)">
                                <i class="fa-regular fa-cart-arrow-down"></i>
                                Aggiungi al carrello
                            </button>
                        </mat-card-content>
                    </mat-card>
                }
            </div>
        }
        @case ('grouped') {
            <div class="catalog-card-list">
                @for (product of groupedProducts; track product.idProdottoMaster) {
                    <mat-card class="catalog-card">
                        <mat-card-content>
                            <div class="catalog-card-header">
                                <span class="body-medium emphasized">{{ product.nomeProdotto }}</span>
                            </div>

                            <span class="body-small">{{ product.descrizioneBreve ?? '-' }}</span>

                            @if (product.specifiche?.length) {
                                <div class="card-row card-row-categories">
                                    <prd-category-chip [badges]="product.specifiche" />
                                </div>
                            }

                            <mat-divider></mat-divider>

                            <button matButton class="catalog-detail-button" (click)="openProductDetail(product.idProdottoMaster)">
                                <i class="fa-regular fa-circle-info"></i>
                                Dettaglio
                            </button>
                        </mat-card-content>
                    </mat-card>
                }
            </div>
        }
    }

    @if (selectedView === 'list' || selectedView === 'card' || selectedView === 'grouped') {
        <mat-paginator
            class="paginator"
            [length]="totalItems"
            [pageSize]="pageSize"
            [pageIndex]="pageIndex"
            [pageSizeOptions]="[5, 10, 25]"
            [hidePageSize]="true"
            (page)="onPageChange($event)">
        </mat-paginator>
    }

    <button matButton="filled" class="cart-floating-button" (click)="cartService.open()"
        [matBadge]="cartService.cart()?.numeroRighe"
        [matBadgeHidden]="!cartService.cart()?.numeroRighe"
        matBadgeColor="warn"
        >
        <i class="fa-regular fa-cart-shopping"></i>
        Carrello
    </button>

</ng-container>
